export default "skymp5-front/63bffae98ce309a30fc2c6e66e668b81.gif";